import { GENERAL, OFFICE_ACTION, PATENT_APPLICATION, type SessionMode } from "@constants/documentCategories";

/**
 * Session record exchanged with the backend. Field names match the wire format
 * (snake_case). DTO ↔ camelCase domain mapping is intentionally deferred.
 */
export type Session = {
  session_id: string;
  session_name: string;
  session_mode: SessionMode;
  document_id: string;
};

export const ALL_SESSION_MODES: readonly SessionMode[] = [PATENT_APPLICATION, OFFICE_ACTION, GENERAL] as const;

export const isOfficeActionMode = (mode: SessionMode | null | undefined): mode is typeof OFFICE_ACTION =>
  mode === OFFICE_ACTION;
